<template lang="pug">
  .group__select-list
    template(v-if="folder")
      span.group__select-list-folder
        | {{folder.name}}
    template(v-if="course")
      .group__select-list-course
        span.group__select-list-text(
          @click="$emit('click',{course})"
        )
          | {{course.name}}
        span.group__select-list-point
          | {{tasksPoint}} работ

    template(v-if="courses")
      SelectItem(
        v-for="field in courses"
        :course="field.course"
        :tasks="field.tasks"
        :key="field.course.id"
        @click="$emit('click', $event)"
      )
</template>

<script>
export default {
  name: 'SelectItem',
  props: {
    folder: {},
    courses: {},
    tasks: {},
    course: {}
  },
  computed: {
    tasksPoint() {
      return this.tasks
        .map(el => el.count)
        .reduce((first, second) => first + second, 0);
    }
  }
};
</script>
